/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTrackingStatusResponse
 */
export interface EmailTrackingStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EmailTrackingStatusResponse
     */
    emailTrackingEnabled: boolean;
}

/**
 * Check if a given object implements the EmailTrackingStatusResponse interface.
 */
export function instanceOfEmailTrackingStatusResponse(value: object): value is EmailTrackingStatusResponse {
    if (!('emailTrackingEnabled' in value) || value['emailTrackingEnabled'] === undefined) return false;
    return true;
}

export function EmailTrackingStatusResponseFromJSON(json: any): EmailTrackingStatusResponse {
    return EmailTrackingStatusResponseFromJSONTyped(json, false);
}

export function EmailTrackingStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTrackingStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'emailTrackingEnabled': json['email_tracking_enabled'],
    };
}

  export function EmailTrackingStatusResponseToJSON(json: any): EmailTrackingStatusResponse {
      return EmailTrackingStatusResponseToJSONTyped(json, false);
  }

  export function EmailTrackingStatusResponseToJSONTyped(value?: EmailTrackingStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email_tracking_enabled': value['emailTrackingEnabled'],
    };
}

